import CorePreviewLine from '@components/CorePreviewLine'
import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import type { CheckoutDetails, PaymentPreview, TransactionViewPortal } from 'mmfintech-backend-api/types'
import { formatFloat, formatMoney, tr } from 'mmfintech-commons'
import moment from 'moment'

import './styled/refundPreview.scss'

export const RefundPreview = ({
  previewData,
  checkoutDetails,
  trn
}: {
  previewData: PaymentPreview
  checkoutDetails: CheckoutDetails
  trn?: TransactionViewPortal
}) => {
  const { id, reqTime } = trn || {}
  const { fee, feeCurrency, walletAmount, walletCurrency } = previewData || {}
  const { customerName, customerEmail } = checkoutDetails || {}

  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className='refund-preview-wrapper'>
      <div className='refund-amount-section'>
        <div className='amount-label'>{tr('FRONTEND.DEPOSIT.AMOUNT_LABEL', 'Amount')}</div>
        <div className='amount-content'>
          {walletAmount > 0 && walletCurrency?.length
            ? formatFloat(walletAmount, getCurrencyPrecision(walletCurrency))
            : null}
          <span className='amount-currency'>{walletAmount > 0 && formatCurrencyForDisplay(walletCurrency)}</span>
        </div>
      </div>

      <div className='refund-details-section'>
        <CorePreviewLine
          className={'transaction-refund-single-content'}
          title={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.CUSTOMER_NAME', 'Customer name')}
          text={customerName}
        />
        <CorePreviewLine
          className={'transaction-refund-single-content'}
          title={tr('FRONTEND.TRANSACTIONS.REFUND_MODAL.CUSTOMER_EMAIL', 'Customer email')}
          text={customerEmail}
        />
        <CorePreviewLine
          className={'transaction-refund-single-content'}
          title={tr('FRONTEND.PENDING_APPROVALS.MODAL.TRANSACTION_ID', 'Transaction ID')}
          text={id?.toString()}
        />
        <CorePreviewLine
          className={'transaction-refund-single-content'}
          title={tr('FRONTEND.EXPENSES.LABEL.DATE', 'Date')}
          text={moment(reqTime).format('DD/MM/YYYY')}
        />
        {fee > 0 ? (
          <CorePreviewLine
            className={'transaction-refund-single-content'}
            title={tr('FRONTEND.EXCHANGE.FEE', 'Fee')}
            text={formatMoney(fee, formatCurrencyForDisplay(feeCurrency))}
          />
        ) : null}
      </div>
    </div>
  )
}
